/* PielPet — interacciones del tema (sin dependencias). */
(function () {
  'use strict';

  /* Animación al hacer scroll */
  function iniciarAnimaciones(raiz) {
    var elementos = (raiz || document).querySelectorAll('.animar:not(.en-vista)');
    if (!document.documentElement.classList.contains('animado')) return;
    var reducir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducir || !('IntersectionObserver' in window) || window.Shopify && window.Shopify.designMode) {
      elementos.forEach(function (el) { el.classList.add('en-vista'); });
      return;
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('en-vista');
          observador.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    elementos.forEach(function (el) { observador.observe(el); });
  }

  /* Botones + y − de cantidad */
  var temporizadorCarrito;
  document.addEventListener('click', function (ev) {
    var boton = ev.target.closest('[data-cantidad]');
    if (!boton) return;
    var input = boton.parentElement.querySelector('input');
    if (!input) return;
    var minimo = parseInt(input.min || '1', 10);
    var valor = parseInt(input.value, 10) || minimo;
    valor = boton.dataset.cantidad === 'mas' ? valor + 1 : Math.max(minimo, valor - 1);
    input.value = valor;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Actualizar el carrito al cambiar la cantidad */
  document.addEventListener('change', function (ev) {
    var input = ev.target.closest('[data-actualizar-carrito]');
    if (!input) return;
    clearTimeout(temporizadorCarrito);
    temporizadorCarrito = setTimeout(function () { input.form.submit(); }, 600);
  });

  /* Galería: cambiar la foto principal */
  document.addEventListener('click', function (ev) {
    var mini = ev.target.closest('[data-miniatura]');
    if (!mini) return;
    var galeria = mini.closest('[data-galeria]');
    var principal = galeria && galeria.querySelector('.galeria__principal img');
    if (!principal) return;
    principal.removeAttribute('srcset');
    principal.removeAttribute('sizes');
    principal.src = mini.dataset.src;
    if (mini.dataset.srcset) {
      principal.srcset = mini.dataset.srcset;
      principal.sizes = '(min-width: 990px) 55vw, 100vw';
    }
    principal.alt = mini.dataset.alt || '';
    galeria.querySelectorAll('[data-miniatura]').forEach(function (b) {
      b.setAttribute('aria-current', b === mini ? 'true' : 'false');
    });
  });

  /* Variantes: precio y disponibilidad */
  function iniciarVariantes(raiz) {
    (raiz || document).querySelectorAll('.form-producto').forEach(function (form) {
      var selector = form.querySelector('[data-selector-variante]');
      var datos = form.querySelector('[data-variantes]');
      if (!selector || !datos || selector.dataset.listo) return;
      selector.dataset.listo = '1';
      var variantes = JSON.parse(datos.textContent);
      var contenedor = form.closest('[data-producto]') || document;
      selector.addEventListener('change', function () {
        var v = variantes.find(function (x) { return String(x.id) === selector.value; });
        if (!v) return;
        contenedor.querySelectorAll('[data-precio]').forEach(function (p) { p.textContent = v.precio; });
        contenedor.querySelectorAll('[data-precio-antes]').forEach(function (p) {
          p.textContent = v.antes || '';
          p.hidden = !v.antes;
        });
        contenedor.querySelectorAll('[data-ahorro]').forEach(function (p) { p.hidden = !v.antes; });
        var boton = form.querySelector('[data-boton-agregar]');
        if (boton) {
          boton.disabled = !v.disponible;
          var texto = boton.querySelector('span');
          if (texto) texto.textContent = v.disponible ? boton.dataset.texto : 'Agotado';
        }
        if (window.history && window.history.replaceState && !(window.Shopify && window.Shopify.designMode)) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* Barra fija de compra: visible cuando ningún botón de compra está en pantalla */
  function iniciarBarra() {
    var barra = document.querySelector('[data-barra-compra]');
    var zonas = document.querySelectorAll('[data-zona-compra]');
    if (!barra || !zonas.length || !('IntersectionObserver' in window)) return;
    var visibles = new Set();
    function actualizar() {
      var mostrar = visibles.size === 0 && window.scrollY > 400;
      barra.classList.toggle('visible', mostrar);
      document.body.classList.toggle('barra-activa', mostrar);
      if (mostrar) { barra.removeAttribute('inert'); } else { barra.setAttribute('inert', ''); }
    }
    var observador = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (e) {
        if (e.isIntersecting) { visibles.add(e.target); } else { visibles.delete(e.target); }
      });
      actualizar();
    });
    zonas.forEach(function (z) { observador.observe(z); });
    window.addEventListener('scroll', actualizar, { passive: true });
  }

  /* Cerrar el menú del celular al tocar un enlace */
  document.addEventListener('click', function (ev) {
    var enlace = ev.target.closest('.menu-movil__panel a');
    if (!enlace) return;
    var menu = enlace.closest('details');
    if (menu) menu.removeAttribute('open');
  });

  function iniciar() {
    iniciarAnimaciones();
    iniciarVariantes();
    iniciarBarra();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  /* Editor de temas: re-iniciar cuando se edita una sección */
  document.addEventListener('shopify:section:load', function (ev) {
    iniciarAnimaciones(ev.target);
    iniciarVariantes(ev.target);
  });
})();
